import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2010, value: 3625270 },
  { year: 2011, value: 2727670 },
  { year: 2012, value: 9959056 },
  { year: 2013, value: 13016448 },
  { year: 2014, value: 14848977 },
  { year: 2015, value: 16129295 },
  { year: 2016, value: 10835408 },
  { year: 2017, value: 18592174 },
  { year: 2018, value: 24206920 },
  { year: 2019, value: 25205094 },
  { year: 2020, value: 32887725 },
  { year: 2021, value: 54418966 },
  { year: 2022, value: 35601804 },
  { year: 2023, value: 43936576 },
  { year: 2024, value: 46853649 },
  { year: 2025, value: 35869784 },
];

const EVENTS = [
  { year: 2010, label: 'Porfirio Lobo' },
  { year: 2014, label: 'JOH (1er T\u00e9rmino)' },
  { year: 2017, label: 'JOH Anuncia Reelecci\u00f3n' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageMedioRadio() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/medio-tv')}>
            &#8592; Televisi&oacute;n
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Radio</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria &middot; Radio &middot; Honduras 2010–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/medio-prensa')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} color="#4ade80" events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageMedioRadio;
